import { motion } from "framer-motion";
import { OCCASIONS } from "../../lib/content";
import { Kicker, Reveal } from "./Reveal";

const Tile = ({ o, i }) => (
  <motion.article
    data-testid={`occasion-${o.code}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
    className={`group relative overflow-hidden text-white shadow-[0_20px_50px_-25px_rgba(20,24,31,.35)] border border-[var(--line)] min-h-[280px] hud-frame ${o.span}`}
  >
    <img src={o.img} alt={o.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition duration-[1.2s] ease-out group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#14181f]/90 via-[#14181f]/35 to-transparent" />
    <div className="relative h-full flex flex-col justify-between p-6 md:p-8">
      <span className="font-mono text-xs text-white bg-[#14181f]/50 self-start px-2 py-1 tracking-[0.3em]">/{o.code}</span>
      <div>
        <h3 className="font-display text-2xl md:text-3xl font-semibold uppercase">{o.title}</h3>
        <p className="mt-3 text-sm md:text-base text-[#e6ebf1] max-w-md">{o.text}</p>
      </div>
    </div>
  </motion.article>
);

export const Occasions = () => (
  <section id="prilezitosti" data-testid="occasions-section" className="py-24 md:py-36">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="grid md:grid-cols-12 gap-8 mb-14">
        <Reveal className="md:col-span-7">
          <Kicker>Příležitosti</Kicker>
          <h2 className="mt-6 font-display text-4xl md:text-6xl font-semibold uppercase leading-[0.95]">Každá akce.<br /><span className="text-[var(--muted)]">Jeden standard.</span></h2>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-5 md:self-end">
          <p className="text-[var(--muted)] text-base md:text-lg leading-relaxed">Ať slavíte ve dvou nebo v pěti stech, připravíme menu, servis i logistiku tak, abyste se mohli věnovat jen svým hostům.</p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-6 md:auto-rows-[280px] gap-4">
        {OCCASIONS.map((o, i) => <Tile key={o.code} o={o} i={i} />)}
      </div>
    </div>
  </section>
);
